import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Bakery/reports/ItemStatisticReport/ItemStatisticReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class BakeryItemStatisticReport extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Bakery/reports/ItemStatisticReport/ItemStatisticReport")
	}

	render() {
		return (
			<Activity 
				name="ItemStatisticReport"
				RenderedComponent={this.RenderedComponent}
				context="ItemStatisticReport"
				action="ItemStatisticReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(BakeryItemStatisticReport)
